<prox-main [parent]="this" [bodyTemplate]="bodyTemplate" [footerTemplate]="footerTemplate"></prox-main>

<ng-template #bodyTemplate>
  <div class="grow" *ngIf="isPageReady">
    <div class="pt-2 pb-4 qb-grid-responsive-1/2 h-full">
      <prox-ag-grid [gridOptions]="gridOptions" [rowData]="eventSummaries" [hasFooter]="false"
        gridId="ag-grid-borderless"
        style="--ag-border-color: transparent; --qb-grid-border-light: transparent; --qb-row-border: transparent;"></prox-ag-grid>
    </div>
  </div>
  <!-- -->
</ng-template>

<ng-template #footerTemplate>
  <prox-save-cancel [uow]="this" (undo)="onUndo()" (save)="onSave()" (cancel)="onCancel()"></prox-save-cancel>
</ng-template>